import React, {Component} from 'react';
import Menu from 'semantic-ui-react/dist/es/collections/Menu';
import Button from 'semantic-ui-react/dist/es/elements/Button';
import Icon from 'semantic-ui-react/dist/es/elements/Icon';
import {Form} from 'formsy-semantic-ui-react';
import Confirm from 'semantic-ui-react/dist/es/addons/Confirm'
import Modal from 'semantic-ui-react/dist/es/modules/Modal'
import Header from 'semantic-ui-react/dist/es/elements/Header'

import './App.css';
import ReactTable from "react-table";
import "react-table/react-table.css";
import global from "./global"
import {RoleEditRecord} from "./RoleEdit"
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import {toast} from 'react-toastify';
import 'semantic-ui-css/semantic.min.css';

export class Roles extends Component {
     componentWillMount = () =>  {
        this.setState({
            access_token: this.props.access_token,
            isLoggedIn: this.props.isloggedIn,
            data: [],
            pages: null,
            loading: true,
            currentpage: 1,
            randomkey: Math.random(),
            showmodal: false,
            searchkey: "",
            pageSize: 20,
            current_user: JSON.parse(sessionStorage.getItem("current_user"))



        });

    }
    notifyError = (errors) => {
        toast.error(errors+"\n(click anywhere to close)",{autoClose: 10000})
    }
    notifySuccess = (msg) => {
        toast.success(msg,{autoClose: 3000})
    }
    DeleteRole = (recid) => {
        confirmAlert({
            title: 'Confirm Delete',                        // Title dialog
            message: 'Are you sure you want to delete this record?',               // Message dialog
            confirmLabel: 'Yes',                           // Text button confirm
            cancelLabel: 'No',                             // Text button cancel
            onConfirm: () => {
                var parms = {
                    id: recid
                }
                var component = this
                global.getFetch("roles/delete", parms, component.state.access_token).then(function (resp) {
                    if (resp.success === "Y") {
                        component.notifySuccess(resp.message)
                        var comp = component;
                        var parms = {
                            pageSize: comp.state.pageSize,
                            page: comp.state.currentpage,
                            sorted: comp.state.sorted,
                            search: comp.state.searchkey
                        }

                        global.getFetch("users", parms, component.state.access_token).then(function (resp) {
                            comp.setState({
                                data: resp.rows,
                                pages: resp.pages,
                                loading: false,
                            });
                        })

                    } else {
                        comp.notifyError(resp.message)

                    }

                })
            }
        })

    }
    loadRecord = (recid) => {
        var parms = {
            id: recid
        }
        var component=this
        global.getFetch("roles/read",parms,this.state.access_token).then(function (resp) {
                component.setState({
                editRecord: resp,
                departments: resp.departments,
                showmodal: true,
                recid: recid,
                editname: resp.rec.name,
                    user_fields: resp.user_fields


                });
        })
    }
    handleConfirm = () => {
        this.isDirty = false
        this.updateTable()
        this.setState({confirmOpen: false, showmodal: false})

    }

    handleCancel = () => {
        this.setState({confirmOpen: false})

    }

    onValidSubmit = (formData) => {
        this.setState({searchkey: formData.search, loading: true, randomkey: Math.random()} )

        var component=this;
        var parms = {
            pageSize: this.state.pageSize,
            page: 1,
            sorted: this.state.sorted,
            search: formData.search
        }

        global.getFetch("roles",parms,this.state.access_token).then(function (resp) {
            component.setState({
                data: resp.rows,
                pages: resp.pages,
                loading: false,
                parms: parms
            });
        })
    }

    handleItemClick = (e, {name}) => {
        this.setState({activeItem: name})
    }

    refreshtable = () => {
        this.refs.searchform.reset()
        this.setState({randomkey: Math.random(), searchkey: ""})
    }

    updateTable = () => {
        var comp = this;
        var parms = {
            pageSize: this.state.pageSize,
            page: this.state.currentpage,
            sorted: this.state.sorted,
            search: this.state.searchkey
        }

        global.getFetch("roles", parms, this.state.access_token).then(function (resp) {
            comp.setState({
                data: resp.rows,
                pages: resp.pages,
                loading: false,
            });
        })

    }

    newRecord = () => {
        var comp=this
        var parms=[]
        global.getFetch("roles/new",parms,this.state.access_token).then(function (resp) {
            comp.setState({
                editRecord: resp,
                departments: resp.departments,
                showmodal: true,
                recid: null,
                editname: "New Record",
                user_fields: resp.user_fields


            });
        })

    }

    handleclose = () => {
        if (this.isDirty) {
            this.setState({confirmOpen: true})
        } else {
            this.setState({showmodal: false})
            this.updateTable()
        }
    }

    showRole = (rowInfo) => {
        this.isDirty = false
        this.loadRecord(rowInfo.row.id)
    }
    setDirty = (val) => {
         this.isDirty = val
    }
    exportdata = () => {
        var srts = this.state.sorted
        if (srts==="") {
            srts="name asc"
        }
        var parms = {
            pageSize: 99999999,
            page: 1,
            sorted: srts,
            search: this.state.searchkey
        }

        global.getFetch("roles/excel",parms,this.state.access_token).then(function (resp) {
            global.openLink('https://apidev.mycontrack.com/showxls?xls='+resp.xls, "_blank")

        })
    }
    fetchData = (state, instance) => {
        // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
        // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
        this.setState({loading: true});
        var asc = ""
        var srts = ""
        state.sorted.map(function (i) {
            asc = (i.desc ? " desc" : " asc")
            srts += (srts === "" ? "" : ",") + (i.id !== "fullname" ? i.id : "last_name " + asc + ", first_name") + (i.desc ? " desc" : " asc")
            return srts
         })
        if (srts==="") {
            srts="name asc"
        }
        var component=this;
        var parms = {
            pageSize: state.pageSize,
            page: state.page + 1,
            sorted: srts,
            search: this.state.searchkey
        }

        global.getFetch("roles",parms,this.state.access_token).then(function (resp) {
            component.setState({
                data: resp.rows,
                pages: resp.pages,
                loading: false,
                currentpage: state.page + 1,
                parms: parms,
                sorted: srts,
                pageSize: state.pageSize
            });
        })
    }

    render() {
        const {user_fields,access_token, data, pages, loading, randomkey, recid, editname, editRecord, pageSize, current_user} = this.state

        return (

            <div>
                <Menu style={{border: 'none'}}>
                    <Menu.Item style={{border: 'none'}}>
                        {current_user.can_create_roles ?

                        <Button size="tiny" icon='write' label="New Role" onClick={this.newRecord}/> : " "}
                        <Button size="tiny" icon='refresh' label="Refresh Page" onClick={this.refreshtable}/>

                    </Menu.Item>
                    <Menu.Menu position='right' style={{border: 'none'}}>
                        <Menu.Item style={{border: 'none'}}>
                            <Button size="tiny" icon="file excel outline" label="Export" onClick={this.exportdata}/>
                        </Menu.Item>
                        <Menu.Item style={{border: 'none'}}>
                            <Form ref="searchform" onValidSubmit={this.onValidSubmit}>
                                <Form.Input name="search" action={{icon: 'search'}} placeholder='Search...'
                                            onChange={this.handleChange}/>
                            </Form>
                        </Menu.Item>
                    </Menu.Menu>

                </Menu>
                <Modal
                    open={this.state.showmodal}
                    size='large' closeIcon
                    closeOnRootNodeClick={true}
                    onClose={this.handleclose}


                >

                    <Header icon='browser' content={editname}/>
                    <Modal.Content>
                        <Confirm
                            open={this.state.confirmOpen}
                            onCancel={this.handleCancel}
                            onConfirm={this.handleConfirm}
                            content="You have unsaved changes. Are you sure?"
                            style={{fontSize: "1.2rem"}}

                        />

                        <RoleEditRecord  user_fields={user_fields} dirtyFlag={this.setDirty} data={editRecord} recid={recid} access_token={access_token} loadRecord={this.loadRecord} updateTable={this.updateTable}/>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button size="tiny" color='green' onClick={this.handleclose} inverted>
                            <Icon name='checkmark'/> Close
                        </Button>
                    </Modal.Actions>
                </Modal>
                <ReactTable
                    key={randomkey}

                    getTdProps={(state, rowInfo, column, instance) => {
                        return {
                            onDoubleClick: (e, handleOriginal) => {
                                // IMPORTANT! React-Table uses onClick internally to trigger
                                // events like expanding SubComponents and pivots.
                                // By default a custom 'onClick' handler will override this functionality.
                                // If you want to fire the original onClick handler, call the
                                // 'handleOriginal' function.

                                if (column.Header==="D") {
                                    this.DeleteRole(rowInfo.row.id)
                                }
                                if (column.Header==="E") {
                                    this.showRole(rowInfo)

                                }
                            }
                        }
                    }}


                    columns={[
                        {
                            Header: "E",
                            Cell: row => (
                                <div class='iconedit'>
                                    <Icon name='edit'/>
                                    <span class="tooltiptext">Double Click to Edit</span>
                                </div>),
                            width: 30
                        },
                        current_user.can_delete_roles ?

                            {
                                Header: "D",
                                Cell: row => (
                                    <div class='iconedit'>
                                        <Icon name='delete'/>
                                        <span class="tooltiptext">Double Click to Delete</span>
                                    </div>),
                                width: 30
                            } :
                            {
                                Header: "",
                                width: 1
                            }
                        ,
                        {
                            Header: "Id",
                            accessor: "id",
                            width: 40
                        },
                        {
                            Header: "Name",
                            id: "name",
                            accessor: "name"
                        }
                    ]}
                    showPaginationTop
                    manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                    data={data}
                    pages={pages} // Display the total number of pages
                    loading={loading} // Display the loading overlay when we need it
                    onFetchData={this.fetchData} // Request new data when things change
                    defaultPageSize={pageSize}
                    className="-striped -highlight"
                />
            </div>


        );
    }
}

